import {css} from "@pandacss/css";
import {FC} from "react";


const spinnerContainer = css({
    width: '20px',
    height: '20px',
    animation: 'spin 0.8s linear infinite',
    color: 'neutral.100'
})

export const SmallLoadingSpinner: FC = () => (
    <svg
        className={spinnerContainer}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
    >
        <path
            d="M10 3
        A7 7 0 1 1 3 10"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
        />
    </svg>
)

export default SmallLoadingSpinner